
import BaseComponent from '../BaseComponent';
import SelectorEngine from '../../utils/dom/selector-engine';
import EventHandler from '../../utils/dom/event-handler';
import Manipulator from '../../utils/dom/manipulator';

const NAME = 'NotificationCard';

class NotificationCard extends BaseComponent {
	constructor(element) {
		super(element);
		this.init();
	}

	static get NAME() {
		return NAME;
	}

	init() {
		EventHandler.on(this._element, 'click', (event) => {
			const notificationElement = event.currentTarget;
			const redirectUrl = Manipulator.getDataAttribute(notificationElement, 'redirectUrl');
			window.location.href = redirectUrl;
		});
	}

}

export default NotificationCard;
